var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{attrs:{"length":_vm.pages,"total-visible":7,"color":_vm.cardSettings.buttonBackgroundColor},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }